import { useState } from 'react'

const PageHeader = ({ data }) => {
    // console.log('data in PageHeader', data)

    const [activeTab, setActiveTab] = useState(null)

    const headerVideoSrc = data.headerVideoSrc ? data.headerVideoSrc : null
    const headerImageSrc = data.headerImageSrc ? data.headerImageSrc : null
    const headerImageAlt = data.headerImageAlt ? data.headerImageAlt : 'header image'

    return (
        <div className="page-header-outer">
            <div className="page-header-inner">
                {headerVideoSrc ? (
                    <div className="page-header-video">
                        <video width="100%" loop autoPlay muted playsInline>
                          <source src={headerVideoSrc} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                    </div>
                ) : (
                    <div className="page-header-image">
                        <img src={headerImageSrc} alt={headerImageAlt} />
                    </div>
                )}
                <div className="page-header-content">

                    <h1 className="page-title">{data.pageTitle}</h1>
                    <div className="header-description page-description">
                        <p>{data.headerDesc}</p>
                    </div>
                    <div className="header-ctas">
                        <ul className="nostyle ctas-list">
                            {data.headerCTAs.map((c, i) => {
                                return (
                                    <li key={c.id} className={`header-cta ${i === activeTab ? 'active-tab' : null}`}>
                                        <a
                                            className="header-cta-link large-button cta-button"
                                            href={c.headerCTALink}
                                            onClick={() => setActiveTab(i)}
                                        >
                                            {c.headerCTA}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageHeader
